export const triggerMobileCalculateTaxes = (zipCode) => {
  const calculateTaxesForm = document.getElementById('tax-calculate-form')
  if (calculateTaxesForm) {
    const zipCodeInput = calculateTaxesForm.querySelector('#zipCode')
    zipCodeInput.value = zipCode
    const submitButton = calculateTaxesForm.querySelector('#tax-calculate')
    submitButton.click()
  }
}
